/*
 * @Author: liuxiaoyan
 * @Date: 2021-10-31 10:51:12
 * @LastEditors: renmanyi
 * @LastEditTime: 2022-10-14 14:26:20
 * @Description: 测评中心路由
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
export default {
  routes: [
    {
      path: '/testReport',
      name: 'testReport',
      component: () => import('@/module/testReport/Template'),
      meta: {
        title: '查看报告',
        keepAlive: true,
        logined: false,
      },
    },
    {
      path: '/testReportPdf',
      name: 'testReport',
      component: () => import('@/module/testReport/TemplatePdf'),
      meta: {
        title: '查看报告',
        keepAlive: true,
        logined: false,
      },
    },
    {
      path: '/reportList',
      name: 'reportList',
      component: () => import('@/module/testReport/List'),
      meta: {
        title: '测评报告',
        keepAlive: true,
        logined: false,
      },
    },
    // 给移动端嵌入临时查看点位图
    {
      path: '/innerCanvas',
      name: 'innerCanvas',
      component: () => import('@/module/testReport/InnerCanvas'),
      meta: {
        title: '体态点位',
        keepAlive: false,
        logined: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/Test.js